import React from 'react';

import { Email, Key, Mobile, Security } from '@bypasslane/clover--icons-sprout-functional'; // Replace with your actual icon imports
import PropTypes from 'prop-types';

export const MfaIcon = ({ device: { type: deviceType } = {}, ...rest }) => {
  if (!deviceType) return;
  switch (deviceType) {
    case 'EMAIL': {
      return <Email {...rest} />;
    }
    case 'SMS': {
      return <Mobile {...rest} />;
    }
    case 'PLATFORM': {
      return <Security {...rest} />;
    }
    case 'SECURITY_KEY': {
      return <Key {...rest} />;
    }
    default: {
      return;
    }
  }
};

export default MfaIcon;
MfaIcon.propTypes = {
  device: PropTypes.shape({
    type: PropTypes.string.isRequired
  }).isRequired
};
MfaIcon.displayName = 'MfaIcon';
